module.exports = __webpack_public_path__ + "img/500.14f9f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/500.png
// module id = JE9E
// module chunks = 85